import { FC } from "react";
import { Class, UpdateClassRequest } from "../../../services/class/class.types";
import { useUpdateClass } from "../../../services/class/class.service";
import { useGenericErrorMessage } from "../../../utils/useGenericErrorMessage/useGenericErrorMessage";
import ClassForm from "../ClassForm";

interface EditClassFormProps {
  classData: Class,
  onSuccess: () => void
}

const EditClassForm: FC<EditClassFormProps> = (
    {
      classData,
      onSuccess
    }
) => {
  const classId = classData.classNo;
  const {
    mutate: updateClass,
    isLoading: updateClassIsLoading,
    isError: updateClassIsError,
    error: updateClassError
  } = useUpdateClass({ classId });

  useGenericErrorMessage([
    {
      isError: updateClassIsError,
      error: updateClassError
    }
  ]);

  const saveClass = (
      requestBody: UpdateClassRequest
  ) => {
    updateClass(
        requestBody,
        {
          onSuccess: onSuccess
        }
    );
  }

  return (
      <ClassForm
          classData={classData}
          submitForm={saveClass}
          submitIsLoading={updateClassIsLoading}
      />
  )
}

export default EditClassForm;